import Phaser from 'phaser';

const eventEmitter = new Phaser.Events.EventEmitter();

/**
 * 
 * @returns {Phaser.Events.EventEmitter}
 */
export function getEventEmitter() {
    return eventEmitter;
}